import { useCartAbandonmentEmailPromoRecommendation } from '../modules/CartAbandonmentEmailPromoRecommendation';
import { useFreeShippingRecommendation } from '../modules/FreeShippingRecommendation/hooks/useFreeShippingRecommendation';
export const useDonationsEmptyStateRecommendations = () => {
    const { freeShippingRecommendation } = useFreeShippingRecommendation();
    const { cartAbandonmentEmailPromoRecommendation } = useCartAbandonmentEmailPromoRecommendation();
    const recommendations = [cartAbandonmentEmailPromoRecommendation, freeShippingRecommendation];
    const isLoadingRecommendations = recommendations.some(({ isLoading }) => isLoading);
    const enabledRecommendations = (() => {
        return recommendations.filter(({ enabled }) => enabled);
    })();
    return { recommendations: !isLoadingRecommendations ? enabledRecommendations : undefined };
};
